import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-736ee30e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("video", {
    class: "main-video",
    autoplay: "",
    muted: "",
    loop: ""
  }, [
    /*#__PURE__*/_createElementVNode("source", {
      src: "https://files.qiniu.ximeiekao.com/mp4/ximeizhanshihc.mp4",
      type: "video/mp4"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Product = _resolveComponent("Product")!
  const _component_News = _resolveComponent("News")!
  const _component_Partner = _resolveComponent("Partner")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, {
      titleId: _ctx.$route.query.titleId == undefined ? 0 : _ctx.$route.query.titleId,
      titleUrl: _ctx.$route.query.titleUrl == undefined ? '' : _ctx.$route.query.titleUrl,
      onHomeVideo: _ctx.homeVideo
    }, null, 8, ["titleId", "titleUrl", "onHomeVideo"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_Product, {
        productModuleImg: _ctx.productModuleTopImg,
        productTitleDesc: _ctx.productTitleDesc,
        titleType: true,
        productModule: _ctx.productModuleTop
      }, null, 8, ["productModuleImg", "productTitleDesc", "productModule"]),
      _createVNode(_component_Product, {
        productModuleImg: _ctx.productModuleBottomImg,
        productModule: _ctx.productModuleBottom
      }, null, 8, ["productModuleImg", "productModule"]),
      _createVNode(_component_News, {
        newsModule: _ctx.newsModule,
        newsList: _ctx.newsList,
        titleFlag: true
      }, null, 8, ["newsModule", "newsList"]),
      _createVNode(_component_Partner, { partnerModule: _ctx.partnerModule }, null, 8, ["partnerModule"])
    ]),
    _createVNode(_component_Bottom)
  ]))
}